import styles from "./style.module.scss";
import { Link } from "react-router-dom";

export const ExperienceFeeSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>
          Experience fee<span>-体験料金一覧-</span>
        </h2>
        <table>
          <thead>
            <tr>
              <th>体験</th>
              <th>料金</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>元祖石巻焼きそばづくり</td>
              <td>
                計10,000円 <small>（食材費込み）</small>
              </td>
            </tr>
            <tr>
              <td>釣船の釣り体験</td>
              <td>
                <span>1名あたり15,000円</span>
                <small>（釣具レンタル・ガイド付き）</small>
              </td>
            </tr>
            <tr>
              <td>ダイビング体験</td>
              <td>
                <span>1名あたり28,000円</span>
                <small>（ダイビング器具一式レンタル込）</small>
              </td>
            </tr>
            <tr>
              <td>森に溶け込むサウナ</td>
              <td>
                計28,000円 <small>（完全貸切）</small>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          ※体験料金や体験内容の詳細は
          <Link to="/activity" className={styles.link}>
            こちら
          </Link>
          をご覧ください。
        </p>
      </div>
    </section>
  );
};
